import { type MantineNumberSize, Stack, type StackProps } from '@mantine/core'
import { compact, map } from 'lodash'
import { type CSSProperties, type FC } from 'react'

import { PropertyListItem } from './PropertyListItem'

export interface PropertyListProps extends Omit<StackProps, 'children'> {
  items: Array<{ label: string; value: any } | null>
  labelWidth?: CSSProperties['width']
  size?: MantineNumberSize
}

export const PropertyList: FC<PropertyListProps> = ({ items, labelWidth, size, ...props }) => (
  <Stack
    spacing='xs'
    {...props}
  >
    {map(compact(items), (item, itemIdx) => (
      <PropertyListItem
        key={`item-${itemIdx}`}
        labelWidth={labelWidth}
        size={size}
        {...item}
      />
    ))}
  </Stack>
)
